import Reveal from "@/components/Reveal";

const FEATURES = [
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/knjudfzs_image%202.png",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/4q49uaqn_vi.png",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/tbvpn2zh_image%204.png",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/portj0hw_hyundai.png",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/u8p5ht1q_WhatsApp%20Image%202026-07-31%20at%2014.14.45.jpeg",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/aiupual6_image.webp",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/nrth8q1r_WhatsApp%20Image%202026-09-28%20at%2013.21.28.jpeg",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/evgihrv9_WhatsApp%20Image%202026-09-28%20at%2013.21.20.jpeg",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/po3xhiot_WhatsApp%20Image%202026-09-28%20at%2013.18.45.jpeg",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/3zekovkn_WhatsApp%20Image%202026-09-28%20at%2013.21.26.jpeg",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/meowo2ar_3bd16250-cf65-43a4-8e40-66a2d1bdcaaa.png",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/dce5px4l_WhatsApp%20Image%202026-09-29%20at%2012.44.02%20%281%29.jpeg",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/bnelq05g_172c8ffa-0eb6-4af0-a13a-4d09dbd1eac4.png",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/9k8yrvg6_f371635f-4ef5-4d4f-b3ad-dc7f728d1025.png",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/qh1jpd2j_WhatsApp%20Image%202026-09-29%20at%2012.44.01.jpeg",
  },
  {
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_led-web-platform/artifacts/vqymama9_beca6a0d-6908-4c63-a8db-91f4e4356df5.png",
  },
];

export const Showcase = () => {
  return (
    <section id="showcase" data-testid="showcase-section" className="relative py-24 lg:py-32 bg-[#0B1220] text-white overflow-hidden">
      <div
        className="absolute inset-0 opacity-70"
        style={{
          backgroundImage:
            "radial-gradient(900px circle at 85% 10%, rgba(0,67,156,0.30), transparent 55%), radial-gradient(700px circle at 5% 95%, rgba(168,137,88,0.10), transparent 60%)",
        }}
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 mb-14">
        <Reveal className="max-w-3xl">
          <div className="text-[12px] uppercase tracking-[0.18em] font-semibold text-[#A88958] mb-3">Reference Installations</div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            A portfolio in
            <br />
            <span className="text-[#A88958]">motion.</span>
          </h2>
          <p className="mt-6 text-white/65 text-base lg:text-lg leading-relaxed max-w-xl">
            A visual reference of LED and LCD display environments — indoor, outdoor, and
            architectural — engineered and deployed by Smart Digi.
          </p>
        </Reveal>
      </div>

      {/* Cinematic dual-row reel — full bleed */}
      <div className="relative space-y-5">
        <ReelRow items={FEATURES.slice(0, 8)} direction="left" duration={60} testid="reel-row-1" />
        <ReelRow items={FEATURES.slice(8)}      direction="right" duration={65} testid="reel-row-2" />

        {/* Side gradient masks so tiles softly fade at edges */}
        <div aria-hidden className="pointer-events-none absolute inset-y-0 left-0 w-24 lg:w-40 bg-gradient-to-r from-[#0B1220] to-transparent" />
        <div aria-hidden className="pointer-events-none absolute inset-y-0 right-0 w-24 lg:w-40 bg-gradient-to-l from-[#0B1220] to-transparent" />
      </div>
    </section>
  );
};

const ReelRow = ({ items, direction = "left", duration = 60, testid }) => {
  const track = [...items, ...items];
  return (
    <div
      data-testid={testid}
      className="overflow-hidden"
    >
      <div
        className="reel-track flex gap-5"
        style={{
          animationDuration: `${duration}s`,
          animationDirection: direction === "left" ? "normal" : "reverse",
        }}
      >
        {track.map((f, i) => (
          <article
            key={i}
            data-testid={`${testid}-item-${i}`}
            className="group relative shrink-0 w-[340px] lg:w-[420px] h-[240px] lg:h-[300px] overflow-hidden rounded-2xl border border-white/8 bg-[#0F172A]"
          >
            <img
              src={f.img}
              alt="LED display installation reference"
              loading="lazy"
              decoding="async"
              className="showcase-img absolute inset-0 w-full h-full object-cover group-hover:scale-[1.05] transition-all duration-[900ms] ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1220]/45 via-transparent to-transparent pointer-events-none" />
          </article>
        ))}
      </div>
    </div>
  );
};

export default Showcase;
